import { EXPORT_SUCCESS_TOAST_MESSAGE_KEY } from '@/hooks/useExportResponseHandlers';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';

export const useExportOptionsToast = (onTriggerRefetch: () => void) => {
  const notify = useToastAPI();

  useEffect(() => {
    const message = sessionStorage.getItem(EXPORT_SUCCESS_TOAST_MESSAGE_KEY);
    if (!message) return;

    notify.pending({
      title: message,
    });
    sessionStorage.removeItem(EXPORT_SUCCESS_TOAST_MESSAGE_KEY);
    onTriggerRefetch();
  }, [notify, onTriggerRefetch]);
};
